import { render, staticRenderFns } from "./ContentMedicalCheckup.vue?vue&type=template&id=02f82b15"
import script from "./ContentMedicalCheckup.vue?vue&type=script&lang=js"
export * from "./ContentMedicalCheckup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports